import React from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import { styled } from '@mui/system';
import { useResponsive } from '../../contexts/ResponsiveContext';
import { AboutInvestorRelationsOverviewStakeholderCommunicationContent } from '../../graphql/pimcore/modules/siteContent/types/AboutInvestorRelationsContent';
import { sanitizeRichText } from '../../graphql/pimcore/modules/siteContent/tools/sanitizeRichText';
import Typography from '@mui/material/Typography';

interface StakeholderCommunicationTableProps {
    cmsContent: AboutInvestorRelationsOverviewStakeholderCommunicationContent;
}

const StakeholderCommunicationTable = ({ cmsContent }: StakeholderCommunicationTableProps) => {
    const { isScreenLg, isScreenSm, isScreenXs } = useResponsive();
    const headers: string[] = cmsContent.table.tableHeader;
    const rows: string[][] = cmsContent.table.tableBody;
    const StyledHeaderCell = styled(TableCell)(() => ({
        backgroundColor: '#B95B3B',
        color: 'white',
        fontWeight: 500,
        fontSize: '12px',
        textAlign: 'center',
        fontFamily: 'Poppins',
    }));

    const cellSx = {
        fontWeight: 500,
        fontSize: '12px',
        textAlign: 'center',
        fontFamily: 'Poppins',
    };

    const StyledTableRow = styled(TableRow)(() => ({
        '&:nth-of-type(odd)': {
            backgroundColor: '#F2F2F2',
        },
    }));

    return (
        <Box marginTop="1rem" marginBottom="0.2rem">
            <Typography
                sx={{
                    fontSize: isScreenSm || isScreenXs ? '16px' : '30px',
                    color: '#B75332',
                    fontWeight: 700,
                    fontFamily: 'Poppins',
                    mb: 2,
                }}
            >
                {cmsContent.title.content}
            </Typography>
            <Box
                sx={{
                    fontSize: isScreenXs ? '12px' : isScreenSm ? '13px' : '15px',
                    color: '#3E3E3E',
                    fontWeight: 500,
                    fontFamily: 'Poppins',
                    marginBottom: '1rem',
                    cursor: 'default',
                }}
            >
                {cmsContent.pageSubtitle.content}
            </Box>
            <TableContainer
                component={Paper}
                sx={{
                    maxWidth: 1000,
                    margin: '0 auto',
                    borderRadius: '0px',
                    overflow: isScreenLg || isScreenSm || isScreenXs ? 'auto' : 'hidden',
                }}
            >
                <Table>
                    <TableHead>
                        <TableRow>
                            {headers.map((header, idx) => (
                                <StyledHeaderCell key={idx}>
                                    {header.split('\n').map((line, index, arr) => (
                                        <React.Fragment key={index}>
                                            {line}
                                            {index < arr.length - 1 && <br />}
                                        </React.Fragment>
                                    ))}
                                </StyledHeaderCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, rowIdx) => (
                            <StyledTableRow key={rowIdx}>
                                {row.map((cell, cellIdx) => (
                                    <TableCell
                                        key={cellIdx}
                                        sx={{
                                            ...cellSx,
                                            textAlign: cellIdx === 0 ? 'center' : 'left',

                                            width:
                                                cellIdx === 0
                                                    ? '5%'
                                                    : cellIdx === 1
                                                      ? '20%'
                                                      : cellIdx === 2
                                                        ? '20%'
                                                        : '12%',
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: sanitizeRichText(cell) || '',
                                        }}
                                    >
                                        {/*{cell}*/}
                                    </TableCell>
                                ))}
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default StakeholderCommunicationTable;
